import { Search, SlidersHorizontal } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

export function ListSearchFilters(props: {
	readonly title: string
	readonly placeholder: string
	readonly search?: string | undefined
	readonly status?: string | undefined
	readonly statuses: readonly { value: string; label: string }[]
	readonly onApply: (filters: { search?: string; status?: string }) => void
	readonly onClear: () => void
}) {
	return (
		<form
			aria-label={props.title}
			className="overflow-hidden rounded-2xl border border-border bg-card shadow-card"
			onSubmit={(event) => {
				event.preventDefault()
				const data = new FormData(event.currentTarget)
				const search = String(data.get("search") ?? "").trim()
				const status = String(data.get("status") ?? "all")
				props.onApply({ ...(search ? { search } : {}), ...(status === "all" ? {} : { status }) })
			}}
		>
			<div className="flex items-center gap-3 border-b border-border-subtle px-5 py-4">
				<span className="flex size-8 items-center justify-center rounded-lg bg-brand-muted text-brand">
					<SlidersHorizontal className="size-4" aria-hidden="true" />
				</span>
				<h2 className="text-subsection font-semibold">{props.title}</h2>
			</div>
			<div className="grid gap-4 p-5 md:grid-cols-[minmax(0,2fr)_minmax(10rem,1fr)_auto] md:items-end">
				<label className="min-w-0">
					<span className="mb-2 block text-label font-semibold uppercase text-subtle-foreground">Search</span>
					<span className="relative block">
						<Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-subtle-foreground" aria-hidden="true" />
						<Input name="search" defaultValue={props.search} maxLength={200} placeholder={props.placeholder} className="h-10 rounded-xl pl-9" />
					</span>
				</label>
				<label className="min-w-0">
					<span className="mb-2 block text-label font-semibold uppercase text-subtle-foreground">Status</span>
					<Select name="status" defaultValue={props.status ?? "all"}>
						<SelectTrigger aria-label="Status" className="h-10 w-full rounded-xl bg-card"><SelectValue /></SelectTrigger>
						<SelectContent position="popper" className="border-border shadow-card">
							<SelectItem value="all">All statuses</SelectItem>
							{props.statuses.map((status) => <SelectItem key={status.value} value={status.value}>{status.label}</SelectItem>)}
						</SelectContent>
					</Select>
				</label>
				<div className="flex gap-2">
					{props.search !== undefined || props.status !== undefined ? <Button type="button" variant="secondary" onClick={props.onClear}>Clear</Button> : null}
					<Button type="submit">Apply filters</Button>
				</div>
			</div>
		</form>
	)
}
